import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useTranslation } from "react-i18next";
import { useSidebar } from "../../context/SidebarContext";
import { Sidebar } from "./Sidebar";
import { Toaster } from "../ui/sonner";
import { cn } from "../../lib/utils";

export const MainLayout = () => {
  const { user, loading } = useAuth();
  const { t } = useTranslation();
  const { isCollapsed } = useSidebar();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-slate-600">{t("app.loading")}</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Si el usuario debe cambiar la contraseña, redirigir a la página de cambio
  if (user.must_change_password) {
    return <Navigate to="/change-password" replace />;
  }

  // Redirect vigilantes to patrol interface
  if (user.role === "vigilante") {
    return <Navigate to="/patrol" replace />;
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar />
      <main 
        className={cn(
          "h-screen overflow-hidden transition-all duration-300",
          isCollapsed ? "lg:ml-[80px]" : "lg:ml-[280px]"
        )}
      >
        <div className="h-full p-6 lg:p-8 overflow-hidden">
          <Outlet />
        </div>
      </main>
    </div>
  );
};
